import { colors } from "../../colors";
import type { BadgeSize, BadgeStyleProps, BadgeVariant } from "./types";

// Default colors
const DEFAULT_COLORS = {
  primary: colors.primary[300],
  white: colors.white,
  gray100: colors.gray[100],
  gray300: colors.gray[300],
  transparent: "transparent",
};

// Default size styles
export const getBadgeSizeStyles = (size: BadgeSize): string => {
  switch (size) {
    case "small":
      return `
        padding: 2px 8px;
        font-size: 0.92em;
        line-height: 1.2;
      `;
    case "large":
      return `
        padding: 6px 12px;
        font-size: 1.2em;
        line-height: 1.6;
      `;
    case "medium":
    default:
      return `
        padding: 4px 10px;
        font-size: 1em;
        line-height: 1.4;
      `;
  }
};

// Default variant styles
export const getBadgeVariantStyles = (
  variant: BadgeVariant,
  styleProps?: BadgeStyleProps,
): string => {
  const { backgroundColor, color, borderColor } = styleProps ?? {};

  switch (variant) {
    case "solid":
      return `
        background-color: ${backgroundColor ?? DEFAULT_COLORS.primary};
        color: ${color ?? DEFAULT_COLORS.white};
        border: 1px solid ${borderColor ?? backgroundColor ?? DEFAULT_COLORS.primary};
      `;
    case "outline":
      return `
        background-color: ${backgroundColor ?? DEFAULT_COLORS.transparent};
        color: ${color ?? DEFAULT_COLORS.primary};
        border: 1px solid ${borderColor ?? color ?? DEFAULT_COLORS.primary};
      `;
    case "ghost":
      return `
        background-color: ${backgroundColor ?? DEFAULT_COLORS.gray100};
        color: ${color ?? DEFAULT_COLORS.primary};
        border: 1px solid ${borderColor ?? DEFAULT_COLORS.transparent};
      `;
    default:
      return "";
  }
};
